module.exports = __webpack_public_path__ + "img/energy_tanpaifang.640c9265.png";